<template>
  <p class="notification-bar-title"><slot /></p>
</template>

<style>
.notification-bar-title {
  line-height: 1.1rem;
  margin: 0 !important;
  font-weight: bold;
  color: #707070;
}
.notification-bar-error .notification-bar-title {
  color: #a0242f;
}
.theme-dark .modal-body .notification-bar-error .notification-bar-title {
  color: #5c191f;
}
</style>

<script>
export default {
  name: 'NotificationBarTitle'
}
</script>
